import React from 'react'
import helpImage from '../../assets/images/help.png';

const LabelField = ({children, className, htmlFor}) => {
  return (
    <label className={'dreamfox-label '+className} htmlFor={htmlFor}>
      {children}
      &nbsp; <img src={helpImage} alt="Help" width="20" height="20" title={children} />
    </label>
  )
}

export default LabelField